import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import {
    DetailSection,
    FieldGrid,
    FieldItem,
    RelatedLink,
    joinParts,
} from "components/detail";

export const BlackUserShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    중지된 사용자 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    중지된 사용자 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="로그인 Id" value={record?.loginId} />
                        <FieldItem label="이름" value={record?.name} />
                        <FieldItem label="별명(닉네임)" value={record?.nickName} />
                        <FieldItem label="권한" value={record?.auth} />
                        {/* 원본 record?.address+"  "+record?.detailAddress 조합 → joinParts */}
                        <FieldItem
                            label="주소"
                            span={2}
                            value={joinParts(
                                [record?.address, record?.detailAddress],
                                "  "
                            )}
                        />
                        <FieldItem label="전화번호" value={record?.phoneNumber} />
                        <FieldItem label="이메일주소" value={record?.emailAddress} />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="상태">
                    <FieldGrid columns={2}>
                        {/* 원본 삼항 그대로 유지 */}
                        <FieldItem
                            label="알림 확인 여부"
                            value={record?.readAlarm === true ? "예" : "아니오"}
                        />
                        {/* 원본 삼항 그대로 유지 */}
                        <FieldItem
                            label="승인 상태"
                            value={
                                record?.approval === "ACCEPT"
                                    ? "완료"
                                    : record?.approval === "WAITING"
                                    ? "대기중"
                                    : "거절"
                            }
                        />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="첨부">
                    <FieldGrid columns={2}>
                        {/* 원본 <Link> to 문자열(필터 파라미터 포함) 그대로 */}
                        <FieldItem
                            label="첨부이미지"
                            value={
                                <RelatedLink
                                    to={`/images?filters[0][field]=targetId&filters[0][operator]=eq&filters[0][value]=${record?.id}&filters[1][field]=category&filters[1][operator]=eq&filters[1][value]=USER`}
                                    label="바로가기"
                                />
                            }
                        />
                    </FieldGrid>
                </DetailSection>

                <DetailSection title="메타 정보">
                    <FieldGrid columns={2}>
                        <FieldItem label="생성일" value={record?.createdDate} />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
